module.exports = __webpack_public_path__ + "img/legite.005b98c8.jpg";